import type { NavigationGuard } from "vue-router";
import { useAuthStore } from "@/application/stores/authStore";
import { useAppStore } from "@/application/stores/app";

const authGuard: NavigationGuard = async (to) => {
  const authStore = useAuthStore();
  const appStore = useAppStore();

  const isToAuth = (to.name as string).includes("auth.");
  const isToError = (to.name as string).startsWith("error");

  if (authStore.isLoginOptional || (isToError && authStore.isLoggedIn)) {
    return true;
  }

  if (!isToAuth && (!authStore.isLoggedIn || !authStore.profile)) {
    appStore.setCurrentLocation();
    return { name: "auth.callback" };
  }

  return true;
};

export default authGuard;
